/**
 * @module tab/tabobserver
 */

import { DomEventData, Observer } from 'ckeditor5/src/engine';
import { env, keyCodes } from 'ckeditor5/src/utils';

/**
 * Delete observer introduces the {@link module:engine/view/document~Document#event:tab} event.
 *
 * @extends {Observer}
 */
export default class TabObserver extends Observer {
	constructor( view ) {
		super( view );

		const document = view.document;

		document.on( 'keydown', ( evt, data ) => {
			const tabData = {};

			if ( data.keyCode != keyCodes.tab ) {
				return;
			}

			tabData.executeDefault = env.isMac ? data.altKey : data.ctrlKey;

			// Save the event object to check later if it was stopped or not.
			let event;
			document.once( 'tab', evt => ( event = evt ), {
				priority: 'highest'
			} );

			document.fire( 'tab', new DomEventData( document, data.domEvent, tabData ) );

			if ( event && event.stop.called ) {
				evt.stop();
			}
		}, {
			priority: 'highest'
		} );
	}

	/**
	 * @inheritDoc
	 */
	observe() { }
}
